import { Component, ErrorInfo } from 'react';
import { connect } from 'react-redux';

// Types
import { ErrorBoundaryProps, ErrorBoundaryState } from './ErrorBoundary.types';

// Config
import { reportErrorToNewRelic } from '@utils/logging/logging-utils';

// Components
import Container from '@components/container';
import TechnicalError from '@components/technical-error';

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);

    this.state = {
      error: undefined,
    };
  }

  static getDerivedStateFromError(error: Error) {
    return { error };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    const { reportErrorToNewRelic } = this.props;

    reportErrorToNewRelic({
      error,
      errorDescription: 'checkout-ui error',
      errorInfo,
    });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    if (error) {
      return (
        <Container background="taupe-20" flex={{ flexDirection: 'col', flexItem: '1-0-auto' }} width="full">
          <Container
            flex={{ alignItems: 'center', flexDirection: 'col', flexItem: '1-0-auto', justifyContent: 'center' }}
            id="main"
            paddingBottom="5"
            relative
            tag="main"
          >
            <TechnicalError />
          </Container>
        </Container>
      );
    }

    return children;
  }
}

export function mapDispatchToProps() {
  return { reportErrorToNewRelic };
}

export default connect(null, mapDispatchToProps())(ErrorBoundary);
